import React from 'react'
import { Result } from 'antd'
import CustomLayout from './Layout'

const ExpirationComp: React.FC = () => {
    return (
        <CustomLayout>
            <Result
                status="403"
                title="Acceso Deshabilidatado"
                subTitle="Esta aplicación ha expirado. Contacta con el administrador."
            />
        </CustomLayout>
    )
}

export default ExpirationComp